// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"07169917","231":"9bc385c6","453":"a69c1ef0","457":"67d75222","551":"4bd58a30","851":"9564b84a","970":"dea7f58a"}[chunkId] + ".chunk.js";
};